import { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { RecorrenciasService } from './Service';
import { Recorrencia } from './types';
const recorrenciasService = new RecorrenciasService()

interface RecorrenciasContextData {
    recorrencias: Recorrencia[];
    loading: boolean;
    error: boolean;
    loadRecorrencias: () => void;
}

const RecorrenciasContext = createContext<RecorrenciasContextData | undefined>(undefined);

export const RecorrenciasProvider = ({ children }: { children: ReactNode }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [recorrencias, setRecorrencias] = useState<Recorrencia[]>([]);

    const loadRecorrencias = async () => {
        try{
            setError(false)
            const {data} = await recorrenciasService.getAll()

            setRecorrencias(data)
        }catch (e) {
            setError(true)
        }finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        loadRecorrencias()
    }, []);

    return (
        <RecorrenciasContext.Provider value={{ recorrencias, loading, error, loadRecorrencias }}>
            {children}
        </RecorrenciasContext.Provider>
    );
};

export const useRecorrencias = () => {
    const context = useContext(RecorrenciasContext);
    if (!context) throw new Error("useRecorrencias deve ser usado dentro de RecorrenciasProvider");
    return context;
};
